import React from "react";
import PropTypes from "prop-types";

const Logo = ({ className, color }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 719.29 115.18"
  >
    <defs>
      <style></style>
    </defs>
    <path
      fill={color}
      d="M86.56,38.82H95V49a22.23,22.23,0,0,1,8.26-8.66,23.66,23.66,0,0,1,24.06.4,23.53,23.53,0,0,1,8.51,9.68,31.21,31.21,0,0,1,3,14,31.48,31.48,0,0,1-3,14.09,22.67,22.67,0,0,1-21.07,13.07,22,22,0,0,1-11.61-3.09A22.43,22.43,0,0,1,95,79.75v29.39H86.56Zm35.16,42.76a16.64,16.64,0,0,0,6.18-6.89,22.94,22.94,0,0,0,2.23-10.34q0-8.91-4.82-14.28T112.5,44.7q-8,0-12.77,5.37T95,64.35a23.2,23.2,0,0,0,2.18,10.34,16.12,16.12,0,0,0,6.18,6.89,18.61,18.61,0,0,0,18.39,0Z"
    />
    <path
      fill={color}
      d="M157,88a25,25,0,0,1-9.52-9.68,28.19,28.19,0,0,1-3.45-14,28.19,28.19,0,0,1,3.45-14A25,25,0,0,1,157,40.69a27.34,27.34,0,0,1,13.88-3.49,26.86,26.86,0,0,1,13.73,3.49A24.38,24.38,0,0,1,194,50.37a28.9,28.9,0,0,1,3.35,14,28.9,28.9,0,0,1-3.35,14A24.38,24.38,0,0,1,184.58,88,29,29,0,0,1,157,88Zm23.1-6.33a16.29,16.29,0,0,0,6.28-6.94,23.12,23.12,0,0,0,2.23-10.39A22.74,22.74,0,0,0,186.35,54a16.64,16.64,0,0,0-6.28-6.94,18.66,18.66,0,0,0-18.59,0A17.19,17.19,0,0,0,155.05,54a21.89,21.89,0,0,0-2.33,10.33,22.25,22.25,0,0,0,2.33,10.39,16.81,16.81,0,0,0,6.43,6.94,19,19,0,0,0,18.59,0Z"
    />
    <path
      fill={color}
      d="M208.18,86.14q-5.93-5.37-6.33-14.29l8.61-.41q.31,6.09,3.85,9.63t10,3.55q5.78,0,9-2.49a7.63,7.63,0,0,0,3.24-6.33,5.57,5.57,0,0,0-2.07-4.66q-2.09-1.62-7.65-2.94c-.68-.13-1.35-.28-2-.45s-1.38-.32-2.13-.46a53.52,53.52,0,0,1-10.33-3,14.32,14.32,0,0,1-6-4.56,12.06,12.06,0,0,1-2.08-7.29,13.54,13.54,0,0,1,2.49-8.06A15.48,15.48,0,0,1,213.65,39a26.62,26.62,0,0,1,10.19-1.82q9.21,0,14.49,4.81t5.87,13.12l-8.31.51a12.37,12.37,0,0,0-3.44-8.46c-2.09-2.06-5-3.09-8.61-3.09a13.42,13.42,0,0,0-8,2.18,6.64,6.64,0,0,0-3,5.62,4.93,4.93,0,0,0,2.64,4.56q2.63,1.52,9.12,2.94l.81.2.81.2a55.49,55.49,0,0,1,10.94,3,14,14,0,0,1,6.13,4.66,13.29,13.29,0,0,1,2.08,7.8,14.36,14.36,0,0,1-2.54,8.41,16.73,16.73,0,0,1-7.24,5.73,27.68,27.68,0,0,1-11.2,2.08Q214.11,91.51,208.18,86.14Z"
    />
    <path
      fill={color}
      d="M259.55,87.2q-3.19-3.49-3.19-9.68V46H248V38.82h8.41v-13h8.51v13h11.24V46H264.87V77.12c0,2.23.56,3.81,1.67,4.76s2.92,1.42,5.42,1.42A32.39,32.39,0,0,0,276,83v7a28.64,28.64,0,0,1-6.08.71Q262.75,90.7,259.55,87.2Z"
    />
    <path
      fill={color}
      d="M285.23,38.82h8.51V51.08a21.88,21.88,0,0,1,5.52-9.27,12.08,12.08,0,0,1,8.56-3.4,19.17,19.17,0,0,1,2.54.16q1.11.15,2.43.45v8a19.39,19.39,0,0,0-5-.61,11.79,11.79,0,0,0-10.28,5.67q-3.8,5.69-3.8,15.61V89.88h-8.51Z"
    />
    <path
      fill={color}
      d="M327.58,88a25,25,0,0,1-9.52-9.68,28.19,28.19,0,0,1-3.45-14,28.19,28.19,0,0,1,3.45-14,25,25,0,0,1,9.52-9.68,27.34,27.34,0,0,1,13.88-3.49,26.88,26.88,0,0,1,13.73,3.49,24.38,24.38,0,0,1,9.37,9.68,28.89,28.89,0,0,1,3.34,14,28.89,28.89,0,0,1-3.34,14A24.38,24.38,0,0,1,355.19,88a29,29,0,0,1-27.61,0Zm23.1-6.33A16.29,16.29,0,0,0,357,74.74a23.12,23.12,0,0,0,2.23-10.39A22.74,22.74,0,0,0,357,54a16.64,16.64,0,0,0-6.28-6.94,17.72,17.72,0,0,0-25,6.94,22,22,0,0,0-2.33,10.33,22.37,22.37,0,0,0,2.33,10.39,16.9,16.9,0,0,0,6.44,6.94,19,19,0,0,0,18.59,0Z"
    />
    <path
      fill={color}
      d="M372.66,38.82h8.41V49a22.23,22.23,0,0,1,8.26-8.66,23.66,23.66,0,0,1,24.06.4,23.46,23.46,0,0,1,8.51,9.68,31.21,31.21,0,0,1,3,14,31.48,31.48,0,0,1-3,14.09,22.67,22.67,0,0,1-21.07,13.07,22,22,0,0,1-11.6-3.09,22.45,22.45,0,0,1-8.16-8.67v29.39h-8.41Zm35.16,42.76A16.5,16.5,0,0,0,414,74.69a22.81,22.81,0,0,0,2.23-10.34q0-8.91-4.81-14.28T398.6,44.7q-8,0-12.77,5.37t-4.76,14.28a23.34,23.34,0,0,0,2.18,10.34,16.12,16.12,0,0,0,6.18,6.89,18.61,18.61,0,0,0,18.39,0Z"
    />
    <path
      fill={color}
      d="M429.7,16.43h8.41V52.09a24.88,24.88,0,0,1,7.5-10.84,18.75,18.75,0,0,1,12.26-4q8.2,0,12.71,5.12t4.51,14.74V89.88h-8.51v-32q0-6.59-2.94-9.93T455,44.6a14.53,14.53,0,0,0-8.76,2.83,18.15,18.15,0,0,0-6,8,30.48,30.48,0,0,0-2.13,11.8V89.88H429.7Z"
    />
    <path
      fill={color}
      d="M493.27,88a24.1,24.1,0,0,1-9.06-9.68A29.86,29.86,0,0,1,481,64.25a29.78,29.78,0,0,1,3.19-13.88,23.71,23.71,0,0,1,9-9.68A25.82,25.82,0,0,1,506.7,37.2a23.75,23.75,0,0,1,12.72,3.29,21.48,21.48,0,0,1,8.15,9.27,32.06,32.06,0,0,1,2.84,13.88c0,1,0,1.76-.1,2.43H489.37q.4,8.93,5.12,13.58t12.41,4.66q6.39,0,10.24-3.09a16.72,16.72,0,0,0,5.47-8.56l7.7.51q-1.62,8.81-8,13.57a25,25,0,0,1-15.4,4.77A26,26,0,0,1,493.27,88Zm24.22-39.56a14.87,14.87,0,0,0-10.79-4.06q-7.09,0-11.55,4.06t-5.47,11.24H522Q521.7,52.51,517.49,48.45Z"
    />
    <path
      fill={color}
      d="M539.88,88.92a6,6,0,0,1-1.77-4.41,5.48,5.48,0,0,1,1.77-4.05,6.06,6.06,0,0,1,4.41-1.72,5.7,5.7,0,0,1,4.1,1.72,5.48,5.48,0,0,1,1.77,4.05,6,6,0,0,1-1.77,4.41,5.64,5.64,0,0,1-4.1,1.78A6,6,0,0,1,539.88,88.92Z"
    />
    <path
      fill={color}
      d="M574.07,64.35l-19-25.53h9.93l14.39,19.35,14.39-19.35h9.62L584.71,64.35l18.74,25.53h-9.72L579.44,70.53,565.05,89.88h-9.82Z"
    />
    <path
      fill={color}
      d="M617,106.5q-5.93-4.26-6.94-12.36l8.61-.51a11.36,11.36,0,0,0,4.41,7.5,14.34,14.34,0,0,0,8.66,2.53A14.92,14.92,0,0,0,639,102a11.25,11.25,0,0,0,4.77-5,17.8,17.8,0,0,0,1.67-8V75a23.44,23.44,0,0,1-7.1,10.74,17.58,17.58,0,0,1-11.65,4q-7.7,0-11.9-5.06T610.54,70V38.82H619v30.4q0,6.48,2.69,9.77c1.79,2.2,4.4,3.3,7.85,3.3a13.06,13.06,0,0,0,8.21-2.84,18.33,18.33,0,0,0,5.67-8,32.26,32.26,0,0,0,2-11.91V38.82h8.81V88.37a23.78,23.78,0,0,1-2.84,11.85,19.39,19.39,0,0,1-8,7.8,24.91,24.91,0,0,1-11.9,2.74A24.26,24.26,0,0,1,617,106.5Z"
    />
    <path
      fill={color}
      d="M661.6,82.49l30.91-36.27h-30.8v-7.4h41.23v7.4L672,82.49h31v7.39H661.6Z"
    />
    <path
      fill={color}
      d="M16,89.88,43.81,18.56h9.73L81.4,89.88H72.08L67.57,78.24H29.47L25,89.88ZM32.23,71H64.78L48.47,28.89Z"
    />
  </svg>
);

Logo.defaultProps = {
  className: ``,
  color: ``
};

Logo.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Logo;
